import React from 'react'
import { connect } from 'react-redux'
import Loader from '../../../../shared/components/Loader.jsx'
import { push } from 'react-router-redux'
import { joinXpressGame as joinXpressGameAction } from '../../../../actions/games/creators/index.js'
import { Link } from 'react-router'
import { handleGameClick, handleErrorCode, showErrorMessage } from '../GamesPageNewLayout/gameUtils.jsx'
import SignIn from '../../header/SignIn.jsx'
import { FormattedMessage } from 'react-intl'
import { messages } from '../GamesPageNewLayout/messages.js'
import { getLanguageType } from 'constants/Language'

class FavoriteGames extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      favoriteGames: [],
      showSignIn: false,
    }
  }

  componentDidMount() {
    const favoriteGames = this.getFavoriteGamesFromStorage()
    this.setState({ favoriteGames })
  }

  getFavoriteGamesFromStorage = () => {
    try {
      const favorites = localStorage.getItem('favoriteGames')
      return favorites ? JSON.parse(favorites) : []
    } catch (error) {
      console.error('Failed to parse favorite games from localStorage:', error)
      return []
    }
  }

  unpinGame = async gameId => {
    const { gamblerId } = this.props

    try {
      const response = await fetch(`/api/games/un-pin/${gameId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ gamblerId }),
      })

      if (response.ok) {
        const updatedFavorites = this.state.favoriteGames.filter(game => game.Id !== gameId)
        this.setState({ favoriteGames: updatedFavorites }, () => {
          localStorage.setItem('favoriteGames', JSON.stringify(updatedFavorites))
        })
      } else {
        throw new Error('Failed to unpin the game')
      }
    } catch (error) {
      console.error('Error unpinning the game:', error)
    }
  }
  handleGameClick = async (gameId, gamblerId) => {
    const language = getLanguageType().name
    try {
      this.setState({ loading: true })

      const response = await fetch(`/api/games/${gameId}/launch/?gamblerId=${gamblerId}&language=${language}`)

      if (!response.ok) {
        throw new Error('Network response was not ok')
      }

      const data = await response.json()

      console.log('Game Data:', data.LaunchUrl)
      window.open(data.LaunchUrl)
    } catch (error) {
      console.error('Failed to fetch game details:', error)
    } finally {
      this.setState({ loading: false })
    }
  }

  openAuthModal = () => {
    const { user } = this.props

    if (user) {
      alert('Игра не доступна')
    } else {
      this.props.dispatch({ type: 'BEGIN_SIGNIN' })
    }
  }

  handleGameClickWrapper = gameId => {
    const { user } = this.props
    this.setState({ isLoading: true })

    handleGameClick(
      gameId,
      user,
      loading => this.setState({ isLoading: loading }),
      errorCode => handleErrorCode(errorCode, showErrorMessage, () => this.openAuthModal())
    )
  }
  renderGame = (game, handleGameClickWrapper, favoriteGames, unpinGame) => {
    const isFavorite = favoriteGames.some(g => g.Id === game.Id)
    const handleFavoriteClick = e => {
      e.stopPropagation()
      unpinGame(game.Id)
    }
    return (
      <div key={game.Id} className="game-card" onClick={() => handleGameClickWrapper(game.Id)}>
        <div className="game-thumbnail">
          { (game.ThumbnailUrl || '').endsWith(".mp4")
          ? (<video poster={game.ThumbnailUrl} autoPlay muted loop controls={false} className="game-image">
              <source src={game.ThumbnailUrl} type="video/mp4" />
            </video>)
          : (<img src={game.ThumbnailUrl} alt={`Game ${game.Name}`} className="game-image" />)
          }
          <h3 className="game-title">{game.Name}</h3>

          <button className={`favorite-button ${isFavorite ? 'favorite' : ''}`} onClick={handleFavoriteClick}>
            {isFavorite ? '★' : '☆'}
          </button>
        </div>
      </div>
    )
  }

  render() {
    const { loading, favoriteGames, showSignIn } = this.state

    if (loading) {
      return <Loader />
    }

    return (
      <div className="favorite-games">
        {showSignIn && <SignIn />}

        <Link to="/games">
          <button className="view-all-button">
            <FormattedMessage {...messages.goBackToGames} />
          </button>
        </Link>
        <h1 className="title">
          <FormattedMessage {...messages.favoriteGames} />
        </h1>
        <div className="game-grid">
          {favoriteGames.length > 0 ? (
            favoriteGames.map(game =>
              this.renderGame(game, this.handleGameClickWrapper, this.state.favoriteGames, this.unpinGame)
            )
          ) : (
            <p className="no-favorites">
              <FormattedMessage {...messages.favoriteGamesNot} />
            </p>
          )}
        </div>
      </div>
    )
  }
}

export default connect(
  (state, dispatch) => {
    const user = state.auth.get('user')
    return {
      gamblerId: user && user.get('gamblerId'),
      languageId: state.application.get('languageId'),
      user,
      dispatch,
    }
  },
  { push, joinXpressGameAction }
)(FavoriteGames)



// WEBPACK FOOTER //
// ./js/sport-betting/components/pages/FavoriteGames/FavoriteGames.jsx